import React from "react";

import styles from "../../style/ChatBotWindow.module.css";

interface CharacterCounterProps {
  current: number;
  max: number;
}

/**
 * Component to display the character count for text input
 */
const CharacterCounter: React.FC<CharacterCounterProps> = ({
  current,
  max,
}) => {
  return (
    <span className={styles.characterCount}>
      {current}/{max} characters
    </span>
  );
};

export default CharacterCounter;
